const getters = {
  navHeight: state => state.app.navHeight
}
export default getters
